import { render, staticRenderFns } from "./documentManagement.vue?vue&type=template&id=0192f71f&"
import script from "./documentManagement.vue?vue&type=script&lang=js&"
export * from "./documentManagement.vue?vue&type=script&lang=js&"
import style0 from "./documentManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports